import React from 'react'
import { AppBar, IconButton, Toolbar, Typography } from '@mui/material'
import { NavLink, useNavigate } from 'react-router-dom'
import { HeaderIcon } from '../Icons/HeaderIcon'
import { useAuth } from '../AuthContext/AuthProvider'
import { Logout } from '@mui/icons-material'
import { APP_PATHS } from '../AppRouter/types'

const HeaderComponent: React.FC = () => {
  const { logout, user } = useAuth()
  const navigate = useNavigate()
  return (
    <AppBar position="relative" color="transparent">
      <Toolbar>
        <Typography
          variant="h6"
          color="black"
          noWrap
          component="div"
          sx={{ flexGrow: 1 }}
        >
          <NavLink to="/" style={{ textDecoration: 'none' }}>
            <HeaderIcon
              fill="white"
              style={{
                height: '2em',
                width: '5em'
              }}
            />
          </NavLink>
        </Typography>
        {user && (
          <IconButton
            onClick={() => {
              logout()
              navigate(APP_PATHS.LOGIN_IN, { replace: true })
            }}
          >
            <Logout />
          </IconButton>
        )}
      </Toolbar>
    </AppBar>
  )
}

export default HeaderComponent
